// src/components/seo/seoHomePage.tsx
import { useMemo } from "react";
import { Helmet } from "react-helmet";

type JsonLdNode = Record<string, any>;
type JsonLdGraph = { "@context": "https://schema.org"; "@graph": JsonLdNode[] };

const SeoHomePage: React.FC = () => {
    const BREADCRUMB: JsonLdNode = {
        "@type": "BreadcrumbList",
        "itemListElement": [
        {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: `${process.env.REACT_APP_WEB_URL}/visitor`,
        },
        ],
    };

    const ORGANIZATION: JsonLdNode = {
        "@type": "Organization",
        "@id": `${process.env.REACT_APP_WEB_URL}#organization`,
        "name": "Lansing Building Products",
        "founder": "Ted Lansing",
        "foundingDate": "1955",
        "url": `${process.env.REACT_APP_WEB_URL}/visitor`,
        "logo": "https://cdn.builder.io/api/v1/image/assets%2Fbd9dcf776ad049b7b73b797c6d7d2b61%2F9aa175b9aaa14ef0a8dce6253c1da220?width=112",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "2221 Edward Holland Drive, Suite 300",
          "addressLocality": "Richmond",
          "addressRegion": "VA",
          "postalCode": "23230",
          "addressCountry": "US"
        },
        "contactPoint": [{
            "@type": "ContactPoint",
            "telephone": "+1-804-266-8893",
            "email": "info@lansingbp.com",
            "contactType": "customer service",
            "areaServed": "US"}
        ],
        "sameAs": [
            "https://www.instagram.com/lansing_bp/",
            "https://www.facebook.com/lansingbuildingproducts/",
            "https://www.linkedin.com/company/lansing-building-products/",
            "https://www.youtube.com/channel/UC_5LR4NyFQ59X1CqyNEKN_Q",
        ],
    };

    const jsonLdGraph: JsonLdGraph = useMemo(
        () => ({
        "@context": "https://schema.org",
        "@graph": [BREADCRUMB, ORGANIZATION],
        }),
        [process.env.REACT_APP_WEB_URL]
    );

    return (
        <Helmet>
        <script type="application/ld+json">
            {JSON.stringify(jsonLdGraph)}
        </script>
        </Helmet>
    );
};

export default SeoHomePage;